<template>
    <div class="claim-modal">
        <el-dialog
            :model-value="WebProfileStore.isEditClaimProposalsModalOpen"
            width="700px"
            :show-close="false"
            class="custom-modal"
            @close="close"
            :title="$trans('web_profile.select_claim_proposal') || 'Select AI Proposal'"
        >
            <span class="dialog-cancel-text" @click="close">
                {{ $trans("profile_dossier.cancel") }}
                <el-icon><Close /></el-icon>
            </span>
            <el-button
                type="primary"
                @click="save"
                :disabled="!selectedClaim"
            >
                {{ $trans("web_profile.save") }}
            </el-button>

            <div class="table-container proposals-container">
                <el-radio-group v-model="selectedClaim" class="proposals-group">
                    <el-radio
                        v-for="(proposal, index) in WebProfileStore.claimProposals"
                        :key="index"
                        :value="proposal"
                        size="large"
                        class="proposal-radio"
                    >
                        <div class="radio-content">{{ proposal }}</div>
                    </el-radio>
                </el-radio-group>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useWebProfileStore } from "@/stores/WebProfileStore";
import { Close } from "@element-plus/icons-vue";

export default {
    name: "EditClaimProposalsModal",
    components: { Close },
    data() {
        return {
            selectedClaim: "",
        };
    },
    computed: {
        ...mapStores(useWebProfileStore),
        isModalOpen() {
            return this.WebProfileStore.isEditClaimProposalsModalOpen;
        },
    },
    watch: {
        isModalOpen(newValue) {
            if (newValue) {
                const currentClaim = this.WebProfileStore.profile.claim;
                const proposals = this.WebProfileStore.claimProposals || [];

                if (proposals.includes(currentClaim)) {
                    this.selectedClaim = currentClaim;
                } else if (proposals.length > 0) {
                    this.selectedClaim = proposals[0];
                } else {
                    this.selectedClaim = currentClaim || "";
                }
            }
        },
    },
    methods: {
        close() {
            this.WebProfileStore.closeEditClaimProposalsModal();
        },
        async save() {
            if (!this.selectedClaim) return;
            try {
                await this.WebProfileStore.updateClaimFromProposals(this.selectedClaim);
                this.$message.success(this.$trans("web_profile.claim_saved"));
            } catch (error) {
                console.error("Error saving claim proposal:", error);
                this.$message.error(this.$trans("global.something_went_wrong"));
            }
        },
    },
};
</script>

<style scoped>
.claim-modal :deep(.el-dialog) {
    --el-dialog-width: 700px;
    top: -100px !important;
}

:deep(.el-dialog__header) {
    padding-bottom: 40px;
}

.table-container {
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 24px;
    padding-top: 10px;
    background-color: #ededed;
    font-family: "Barlow", sans-serif;
    padding-right: 25px;
    padding-left: 20px;
}

.proposals-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    width: 100%;
}

.proposal-radio {
    margin-right: 0;
    height: auto;
    white-space: normal;
    display: flex;
    align-items: center;
    width: 100%;
    background-color: #ffffff;
    padding: 15px 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    border: 1px solid transparent;
    transition: all 0.3s ease;
    box-sizing: border-box;
}

.proposal-radio:hover {
    border-color: #41abc4;
    background-color: #fbfdfe;
}

.proposal-radio.is-checked {
    border-color: #41abc4;
    background-color: #f0f9fb;
}

:deep(.el-radio__label) {
    padding-left: 0 !important;
    width: 100%;
}

.radio-content {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.4;
    color: #000;
    padding-left: 10px;
}

:deep(.el-radio__input) {
    display: flex;
    align-items: center;
}

.el-button {
    float: right;
    margin-top: -35px;
    background-color: #41abc4;
    border-color: #41abc4;
    border-radius: unset;
    width: 200px;
    font-size: 16px !important;
    font-weight: 700 !important;
}

.dialog-cancel-text {
    position: absolute;
    top: 5px;
    right: 21px;
    cursor: pointer;
    font-size: 14px;
    color: #909399;
    font-weight: 500;
    z-index: 2000;
    user-select: none;
}

.dialog-cancel-text:hover {
    color: #41abc4;
}

.dialog-cancel-text :deep(.el-icon) {
    top: 3px;
    transform: scale(1.4);
}

:deep(.el-dialog__title) {
    font-size: 1.5rem;
}

:deep(.el-button.is-disabled),
:deep(.el-button.is-disabled:hover),
:deep(.el-button.is-disabled:focus) {
    background-color: #bababa !important;
    border-color: #bababa !important;
    color: #ffffff !important;
    cursor: not-allowed !important;
    opacity: 1 !important;
}
</style>